import { JobEntity } from '../../Entities/Job.Entity';
import { BaseFrontEndApiCalls } from './Base/Base.FrontEnd.Api.Calls';

export class JobFrontEndApiCalls extends BaseFrontEndApiCalls {
    protected static _Entity = JobEntity;

    // #region api

    // #endregion api
}
